import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Checkbox({ label, className = '', id, ...props }) {
    const checkboxId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (_jsxs("div", { className: "flex items-center", children: [_jsx("input", { type: "checkbox", id: checkboxId, className: `
          h-4 w-4 rounded border-gray-300 text-blue-600
          focus:ring-2 focus:ring-blue-500
          disabled:opacity-50 disabled:cursor-not-allowed
          ${className}
        `, ...props }), label && (_jsx("label", { htmlFor: checkboxId, className: "ml-2 text-sm text-gray-700 cursor-pointer", children: label }))] }));
}
